import "./statusPage.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Stack, Typography, Link } from "@mui/material";
import _ from "lodash";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import IconSuccess from "../../assets/images/icons/icon-success.png";
import { LinearText } from "../../utils";

export const StatusPage = () => {
    const navigate = useNavigate();
    const { data } = useSelector((state: RootState) => state.status)

    useEffect(() => {
        if(_.isEmpty(_.get(data, "message"))) {
            navigate("/")
        }
    }, []);
    
    return (
        <Container maxWidth="md"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '80vh'
            }}
        >
            <Stack gap={5} display={'flex'} justifyContent={'center'} alignItems={'center'} textAlign={'center'}>
                <img src={IconSuccess} alt="IconSuccess" width={120} height={'auto'} />
                <Stack gap={0}>
                    <Typography fontSize={38} fontWeight={600}>
                        {_.get(data, "message") || ''}
                        <LinearText>Success!</LinearText>
                    </Typography>
                    <Link
                        fontSize={12}
                        fontWeight={400}
                        href={`${process.env.REACT_APP_SIX_SCAN_TX}/${_.get(data, "txHash")}`}
                        underline="always"
                        target="_blank"
                        // rel="noopener"
                        sx={{
                            overflowWrap: "break-word",
                            color: "var(--black)",
                            textTransform: "unset"
                        }}>
                        {_.get(data, "txHash")}
                    </Link>
                    <Typography fontSize={28} fontWeight={400}>
                        {_.get(data, "description" , "")}
                    </Typography>
                </Stack>

            </Stack>
        </Container>
    );
};

export default StatusPage;
